import React, { useState, useEffect } from 'react';
import { Box, Paper, Typography, Checkbox, FormControlLabel, Switch, Button, Divider, TextField, FormControl, Select, InputLabel, MenuItem } from '@material-ui/core';
import SettingsIcon from '@material-ui/icons/Settings';
import IndividualLinks from './IndividualLinks';
import MasiveLinks from './MasiveLinks';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));
export function LinksCobro(props) {
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  const [tipo, setTipo] = React.useState('');
  const [nombreusuario, setNombreUsuario] = React.useState(props.nombre_usuario || '');
  const [idUsuario, setIdUsuario] = useState(props.id_usuario || null);
  const [expiredToken, setExpiredToken] = useState('1d')
  const [campaña, setCampaña] = useState("")
  const [errorCampaña, setErrorCampaña] = useState(false)
  const backHomeStep = setActiveStep

  useEffect(() => {
    // Si se pasa un nombre de usuario, actualizar el estado
    if (props.nombre_usuario) {
      setNombreUsuario(props.nombre_usuario);
    }
    
  }, [props.nombre_usuario]);

  useEffect(() => {
    // Si se pasa un nombre de usuario, actualizar el estado
    if (props.id_usuario) {
      setIdUsuario(props.id_usuario);
    }
    
  }, [props.id_usuario]);



  const onChangeCampaña = (e) => {
    e.preventDefault()
    setCampaña(e.target.value)
  }

  const validateCampaña = () => {
    if (campaña === "") {
      setErrorCampaña(true)
    } else {
      setErrorCampaña(false)
    }
  }


  // Stepper siempre visible
  const StepperSection = (
    <Paper
      elevation={0}
      style={{
        borderRadius: 20,
        background: "#fafafa",
        padding: 0,
        marginBottom: 32,
        height: 50,
        minHeight: 50,
        width: "100%",
        display: "flex",
        alignItems: "center",
        // Elimina marginLeft y marginRight para alinear con Preferencias
        boxSizing: "border-box"
      }}
    >
      <Box display="flex" alignItems="center" p={2} pl={3} width="100%">
        <Typography variant="h6" style={{ fontWeight: 200, flex: 1 }}>
          Configura tu link
          <SettingsIcon style={{ marginLeft: 12, verticalAlign: "middle" }} />
        </Typography>
        <Box flex={2} display="flex" alignItems="center" justifyContent="center">
          <Box width="100%" display="flex" alignItems="center">
            <Box flex={1} height={2} bgcolor="#e0e0e0" />
            {/* Step 1 */}
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              width={32}
              height={32}
              borderRadius="50%"
              bgcolor={activeStep === 0 ? "rgb(255,81,0)" : "#fff"}
              color={activeStep === 0 ? "#fff" : "#222"}
              fontWeight="bold"
              fontSize={18}
              mx={1}
              border={`2px solid ${activeStep === 0 ? "#fff" : "#bbb"}`}
              boxShadow={activeStep === 0 ? "0 2px 8px rgba(255,81,0,0.15)" : "none"}
            >
              1
            </Box>
            <Box flex={1} height={2} bgcolor="#e0e0e0" />
            {/* Step 2 */}
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              width={32}
              height={32}
              borderRadius="50%"
              bgcolor={activeStep === 1 ? "rgb(255,81,0)" : "#fff"}
              color={activeStep === 1 ? "#fff" : "#222"}
              fontWeight="bold"
              fontSize={18}
              mx={1}
              border={`2px solid ${activeStep === 1 ? "rgb(255,81,0)" : "#bbb"}`}
              boxShadow={activeStep === 1 ? "0 2px 8px rgba(255,81,0,0.15)" : "none"}
            >
              2
            </Box>
            <Box flex={1} height={2} bgcolor="#e0e0e0" />
          </Box>
        </Box>
      </Box>
    </Paper>
  );

  // Paso 2: IndividualLinks o MasiveLinks con botón atrás
  if (activeStep === 1 && tipo === 'individual') {
    return (
      <Box p={3} maxWidth="88%">
        {StepperSection}
        <Box mt={2} style={{ fontFamily: 'Helvetica', fontSize: 16 }}>
          <Typography style={{ fontWeight: 500, fontSize: 16, marginBottom: 8 }}>
            Paso 2: Finalizar
          </Typography>
          <Divider style={{ margin: "8px 0 24px 0" }} />
        </Box>

        <IndividualLinks
          nombre_usuario={props.nombre_usuario}
          id_usuario={idUsuario}
          expired={expiredToken}
          id_commerce={props.id_commerce}
          token={props.token}
          setActiveStep={setActiveStep}

        />



      </Box>
    );
  }
  if (activeStep === 1 && tipo === 'masivo') {
    return (
      <Box p={3} maxWidth="88%">
        {StepperSection}
        <Button
          variant="outlined"
          style={{
            marginBottom: 24,
            borderRadius: 12,
            fontWeight: "bold",
            color: "#ff5100",
            border: "1.5px solid #ff5100",
            fontSize: 16,
            textTransform: "none"
          }}
          onClick={() => setActiveStep(0)}
        >
          Atrás
        </Button>
        <MasiveLinks nombre_usuario={props.nombre_usuario} expired={expiredToken} campaña={campaña} id_commerce={props.id_commerce} token={props.token} setActiveStep={setActiveStep} setCampaña={setCampaña} setTipo={setTipo} setExpiredToken={setExpiredToken} />
      </Box>
    );
  }

  // Paso 1: Selección de tipo de enlace
  return (
    <Box p={3} maxWidth="88%">
      {StepperSection}
      <Box mt={2} style={{ fontFamily: 'Helvetica', fontSize: 16 }}>
        <Typography style={{ fontWeight: 500, fontSize: 16, marginBottom: 8 }}>
          Paso 1: Preferencias
        </Typography>
        <Divider style={{ margin: "8px 0 24px 0" }} />

        {/* Individual */}
        <Box display="flex" alignItems="center" mb={3}>
          <Typography style={{ minWidth: 220, fontSize: 16 }}>Individual</Typography>
          <Checkbox
            checked={tipo === 'individual'}
            onChange={() => setTipo('individual')}
            color="default"
            style={{ width: 28, height: 28 }}
          />
        </Box>

        {/* Masivo */}
        <Box display="flex" alignItems="center" mb={3}>
          <Typography style={{ minWidth: 220, fontSize: 16 }}>Masivo</Typography>
          <Checkbox
            checked={tipo === 'masivo'}
            onChange={() => setTipo('masivo')}
            color="default"
            style={{ width: 28, height: 28 }}
          />
        </Box>

        {(tipo === 'individual' || tipo === 'masivo') && (
          <Box display="flex" alignItems="center" mb={3}>
            <Typography style={{ minWidth: 220, fontSize: 16 }}>Fecha de expiración </Typography>
            <Select
              value={expiredToken}
              onChange={e => setExpiredToken(e.target.value)}
              variant="outlined"
              style={{ fontSize: 16, minWidth: 140, height: 40, fontFamily: 'Helvetica', }}
            >
              <MenuItem value="1d">1 Día</MenuItem>
              <MenuItem value="2d">2 Días</MenuItem>
              <MenuItem value="3d">3 Días</MenuItem>
              <MenuItem value="7d">7 Días</MenuItem>
            </Select>
          </Box>
        )}

        {tipo === 'masivo' && (
          <Box display="flex" alignItems="center" mb={3}>
            <Typography style={{ minWidth: 220, fontSize: 16 }}>Campaña</Typography>
            <TextField
              variant="outlined"
              placeholder="Descripción de la campaña"
              value={campaña}
              onChange={onChangeCampaña}
              onBlur={validateCampaña}
              style={{ fontSize: 16, fontFamily: 'Helvetica', minWidth: 400 }}
              InputProps={{
                style: { fontSize: 16, fontFamily: 'Helvetica', height: 40 }
              }}
              error={errorCampaña}
            />
            {errorCampaña && (
              <Typography style={{ color: '#e53935', marginLeft: 16, fontSize: 16 }}>
                Requerido
              </Typography>
            )}
          </Box>
        )}

        <Box display="flex" justifyContent="flex-end" mt={4}>
          <Button
            variant="outlined"
            style={{
              background: '#fff',
              color: '#ff5100',
              height: 40,
              fontSize: 16,
              borderRadius: 4,
              minWidth: 180,
              boxShadow: 'none',
              border: '2.5px solid #ff5100',
              textTransform: 'none',
              padding: '8px 0'
            }}
            onClick={() => {
              if (tipo === 'masivo') {
                validateCampaña();
                if (!campaña) return; // No avanza si está vacío
              }
              if (tipo && (tipo !== 'masivo' || campaña)) setActiveStep(1);
            }}
            disabled={!tipo}
          >
            Siguiente
          </Button>
        </Box>
      </Box>
    </Box >
  );
}

export default LinksCobro;